import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { cashinForMng } from 'services/loans'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

/** `actorRole` — who recorded it (`bnk` for a «بانی»), for analytics only */
export default function useSetCashinMng(actorRole?: string) {
    const finishFlow = useFinishFlow(FLOWS.deposit)
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IFuckingPayload) => {
            return cashinForMng(payload)
        },
        onSuccess: (data, variables) => {
            posthog.capture('payment_recorded', { flow_type: 'manager_record', amount: (variables as any)?.amount, actor_role: actorRole })
            toast.success('واریز با موفقیت ثبت شد')
            // back to the fund the deposit was registered in, the way Android
            // does (MoneypoolPayActivity:425) — the fund list loses the context
            // the manager was working in. Leaving the flow rather than pushing
            // the fund on top of it: back from there used to reopen this
            // receipt, with «پرداخت تنها ثبت شود» still live on it.
            const moneyPoolId = (variables as any)?.moneyPool
            finishFlow(moneyPoolId ? `/fund/${moneyPoolId}` : '/funds')
        },
        onError: (error: any) => {
            posthog.capture('payment_record_failed', { flow_type: 'manager_record', actor_role: actorRole, status: error?.response?.status })
            toast.error(
                error?.response?.status === 403
                    ? 'ثبت پرداخت فقط با مدیر صندوق یا بانیِ دارای دسترسی ثبت واریز است'
                    : 'خطایی رخ داده'
            )
        },
    })

    return { isLoading, mutate }
}
